import { createTypes } from 'reduxsauce'
 
export default createTypes(`
  FETCH_OBJECT
  FETCH_OBJECT_SUCCESS
  FETCH_OBJECT_FAILURE

  FETCH_BOAT_TYPES
  FETCH_BOAT_TYPES_SUCCESS
  FETCH_BOAT_TYPES_FAILURE

  FETCH_JETTY_TYPES
  FETCH_JETTY_TYPES_SUCCESS
  FETCH_JETTY_TYPES_FAILURE

  FETCH_DRIVE_TYPES
  FETCH_DRIVE_TYPES_SUCCESS
  FETCH_DRIVE_TYPES_FAILURE

  UPDATE_OBJECT
  UPDATE_OBJECT_SUCCESS
  UPDATE_OBJECT_FAILURE

  SAVE_OBJECT

  SELECT_OBJECT
 
`, {});
